import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";
import BuscarAsociado from "./Socio/BuscarAsociado";
import { v4 as uuidv4 } from "uuid";

import { useDispatch, useSelector } from "react-redux";
import {
  obtenerTodosLosClientesConDetalleParaAsociado,
} from "../../redux/InformacionValidaDucks";
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from "../../redux/AppDucks";

function PanelBuscarAsociado(props) {
  const dispatch = useDispatch();


  let dataAsociado = useSelector(store => store.InformacionValidaApi?.dataAsociado);

  const [value, setValue] = React.useState(0);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(async () => {
    await dispatch(actualizarLoadingApp_true())
    let resultado = await dispatch(obtenerTodosLosClientesConDetalleParaAsociado());
    await dispatch(actualizarLoadingApp_false())
  }, []);


  const dataTableHead = ["Número de Cliente", "Nombre"];

  return (
    <Fragment>
      <br />

      <div className="container">
        <div className="bg-light p-2 rounded ms-5">
          {/*<Box sx={{ width: "100%" }}>
            <Tabs value={value} onChange={handleChange} centered>
              <Tab label="Asociados" />
            </Tabs>
  </Box>*/}

          <div className="pt-2">
            {//value === 0 && (
              <BuscarAsociado dataValues={dataAsociado} dataPredio={dataAsociado} dataTableHead={dataTableHead} ></BuscarAsociado>
              //)}
            }
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default withRouter(PanelBuscarAsociado);